export const getFormattedTime = duration => {
  const seconds = Math.floor((duration / 1000) % 60)
  const minutes = Math.floor(duration / 1000 / 60)
  //   const hours = Math.floor((duration / 1000 / 60 / 60) % 24)
  //   return `${hours ? `${hours}h` : ''} ${minutes ? `${minutes}min` : ''}`
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
}
